module.exports = __webpack_public_path__ + "img/sound-decision-maker.c8426d2f.svg";